var _a;
import { get } from 'lodash';
import { RegionType, SocialFollowButtons, } from '@wix/shoutout-email-model-v3';
import { verifyOrFallbackTextColor } from '../../utils/verify-or-fallback';
import * as cssUtils from '../../utils/css-utils';
import getSocialIconUrl from './get-social-icon-url';
import { resolveIconSize, resolveInnerPadding, resolveTitle } from './utils';
var nameToAltTextKey = (_a = {},
    _a[SocialFollowButtons.facebook] = 'COMPOSER.FOLLOW.ALT.FACEBOOK',
    _a[SocialFollowButtons.instagram] = 'COMPOSER.FOLLOW.ALT.INSTAGRAM',
    _a[SocialFollowButtons.linkedIn] = 'COMPOSER.FOLLOW.ALT.LINKEDIN',
    _a[SocialFollowButtons.pinterest] = 'COMPOSER.FOLLOW.ALT.PINTEREST',
    _a[SocialFollowButtons.soundCloud] = 'COMPOSER.FOLLOW.ALT.SOUNDCLOUD',
    _a[SocialFollowButtons.twitter] = 'COMPOSER.FOLLOW.ALT.TWITTER',
    _a[SocialFollowButtons.youtube] = 'COMPOSER.FOLLOW.ALT.YOUTUBE',
    _a);
export function getFollowSection(_a) {
    var region = _a.region, css = _a.css;
    if (region.type !== RegionType.Follow) {
        throw Error('Follow must be passed');
    }
    var fallbackIconColor = get(css, 'so-global-footer-icon.fill');
    var iconColor = verifyOrFallbackTextColor(get(css, 'so-global-region-follow-icon.fill', fallbackIconColor));
    var socialButtons = {
        size: resolveIconSize(region.data),
        innerPadding: resolveInnerPadding(region.data),
        buttons: region.data.socialButtons
            .filter(function (item) { return item.active; })
            .filter(isValidSocialNetwork)
            .map(function (item) { return ({
            name: item.name,
            url: item.url,
            active: item.active,
            iconUrl: getSocialIconUrl(item.name, iconColor),
            alt: nameToAltTextKey[item.name],
        }); }),
    };
    var rules = [css['so-global-region-follow'], css['so-global-region']];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    var padding = cssUtils.padding(rules);
    var margin = cssUtils.margin(rules);
    return {
        cssClass: mobileCssClass,
        title: resolveTitle(css, region.data),
        socialButtons: socialButtons,
        outerPadding: margin,
        innerPadding: padding,
    };
}
function isValidSocialNetwork(social) {
    return [
        SocialFollowButtons.facebook,
        SocialFollowButtons.instagram,
        SocialFollowButtons.linkedIn,
        SocialFollowButtons.pinterest,
        SocialFollowButtons.soundCloud,
        SocialFollowButtons.twitter,
        SocialFollowButtons.youtube,
    ].includes(social.name);
}
//# sourceMappingURL=get-follow-section.js.map